import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-textoaceptacion',
    templateUrl: './textoaceptacion.component.html',
    styleUrls: ['./textoaceptacion.component.scss'],
    standalone: false
})
export class TextoaceptacionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
